import { css } from '@/styled-system/css';

// Light mode shows a 1px outlined-neutral border; dark mode drops it so the
// pill blends into the dark surface.
export const searchWrapper = css({
  width: '100%',
  padding: 'tightest',
  borderRadius: 'pill',
  backgroundColor: 'bg.action.neutral.alt.default',
  borderStyle: 'solid',
  borderColor: 'border.action.neutral.default',
  borderWidth: { base: 'default', _dark: 'zero' },
});
